import { render, staticRenderFns } from "./amp.vue?vue&type=template&id=090052df&"
import script from "./amp.vue?vue&type=script&lang=js&"
export * from "./amp.vue?vue&type=script&lang=js&"
import style0 from "./amp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports